import Vue from 'vue'
import Vuex from 'vuex'
import { login, getUserInfo } from '@/api/auth'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: sessionStorage.getItem('token') || '',
    userInfo: JSON.parse(sessionStorage.getItem('userInfo') || 'null'),
    menus: JSON.parse(sessionStorage.getItem('menus') || '[]'),
    permissions: JSON.parse(sessionStorage.getItem('permissions') || 'null')
  },
  getters: {
    // null = 主账号(全部权限), [] = 无权限, [...] = 限定权限
    permissions: state => state.permissions,
    hasPermission: state => perm => {
      if (state.permissions === null) return true   // 主账号全部可见
      if (!state.permissions || state.permissions.length === 0) return false
      return state.permissions.includes(perm)
    }
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      sessionStorage.setItem('token', token)
    },
    SET_USER_INFO(state, info) {
      state.userInfo = info
      sessionStorage.setItem('userInfo', JSON.stringify(info))
    },
    SET_MENUS(state, menus) {
      state.menus = menus
      sessionStorage.setItem('menus', JSON.stringify(menus))
    },
    SET_PERMISSIONS(state, permissions) {
      state.permissions = permissions
      sessionStorage.setItem('permissions', JSON.stringify(permissions))
    },
    LOGOUT(state) {
      state.token = ''
      state.userInfo = null
      state.menus = []
      state.permissions = null
      sessionStorage.removeItem('token')
      sessionStorage.removeItem('userInfo')
      sessionStorage.removeItem('menus')
      sessionStorage.removeItem('permissions')
    }
  },
  actions: {
    async login({ commit }, { username, password }) {
      const res = await login({ username, password })
      commit('SET_TOKEN', res.data.token)
      commit('SET_USER_INFO', {
        userId: res.data.userId,
        username: res.data.username,
        realName: res.data.realName,
        customerCode: res.data.customerCode,
        companyName: res.data.companyName || '',
        displayName: res.data.displayName || '',
        logoUrl: res.data.logoUrl || '',
        avatar: res.data.avatar || '',
        roleType: res.data.roleType,
        subAccountId: res.data.subAccountId || null,
        subAccountName: res.data.subAccountName || '',
        dataScope: res.data.dataScope || 'ALL'
      })
      commit('SET_MENUS', res.data.menus || [])
      commit('SET_PERMISSIONS', res.data.permissions !== undefined ? res.data.permissions : null)
      return res
    },
    logout({ commit }) {
      commit('LOGOUT')
    }
  }
})
